export default "__VITE_ASSET__bdb8cdc4__"